import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { DataTableWrapper } from "../../../../components/data/DataTable";
import XrInputAv from "../../../../components/XrInputAv";
import XrButtonAv from "../../../../components/XrButtonAv";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { setBooking } from "../../../../redux/reducers/bookings/actions";
import React, { useState } from "react";
import { EnumStatus } from "../../../../interfaces/Enums";

const BookingManageRooms = () => {
  const dispatch = useDispatch();
  const [updateIncr, forceUpdate] = useState(false);
  const booking = useSelector((state: RootState) => state.booking.selectedBooking);
  
  const disableChange = !(booking && booking.status === 0) || false;

  const onChangeDescription = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    const rooms = booking.rooms;
    rooms[index].description = e.target.value
    dispatch(setBooking({
      ...booking,
      rooms
    }));
  }

  const onChangeApproval = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    const rooms = booking.rooms;
    forceUpdate(!updateIncr);
    if (e.target.checked) {
      rooms[index].status = EnumStatus.APPROVED;
      dispatch(setBooking({
        ...booking,
        rooms
      }));
    } else {
      rooms[index].status = EnumStatus.REJECTED;
      dispatch(setBooking({
        ...booking,
        rooms
      }));
    }
  }

  const actionDeleteRoom = (index: number) => {
    if (!booking) return;
    const rooms = booking.rooms;
    rooms.splice(index, 1);
    forceUpdate(!updateIncr);
    dispatch(setBooking({
      ...booking,
      rooms
    }));
  }

  return (
    <DataTableWrapper style={{ margin: '0px' }}>
      <div className="tablewrapper--table">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Setujui</th>
              <th>Keterangan</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {booking?.rooms.map((room, index) => (
              <tr key={index}>
                <td>{room.room_detail?.room_name}</td>
                <td width={30}>
                  <input type='checkbox'
                    disabled={disableChange}
                    checked={room.status === EnumStatus.APPROVED}
                    onChange={(e) => onChangeApproval(index, e)}
                  />
                </td>
                <td>
                  <XrInputAv
                    type='text'
                    required={false}
                    value={room.description}
                    disabled={disableChange}
                    onChange={(e) => onChangeDescription(index, e)}
                  />
                </td>
                <td>
                  <XrButtonAv
                    noBlock
                    size='small'
                    color='danger'
                    icon={faTrash}
                    disabled={disableChange}
                    onClick={() => actionDeleteRoom(index)}
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan={3}>
                {/* <XrInputAv
                  type='text'
                  label={'Cari ruangan lain'}
                  required={false}
                /> */}
              </td>
              <td>
               
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DataTableWrapper>
  );
}

export default BookingManageRooms;